<template>
  <NetWork v-if="networkError" @refreshs="refresh" ></NetWork>
  <div class="aggregate_allCity" v-else-if="!networkError && showOpenCityContent">
    <van-sticky>
    <div class="aggregate_allCity_search">
      <van-search
        v-model="searchValue"
        shape="round"
        placeholder="请输入城市"
      />
    </div>
    </van-sticky>
    <div class="aggregate_allCity_list">
      <van-index-bar v-for="(item, index) in openCityList" :key='index'>
        <van-index-anchor :index='item.key' />
        <van-cell :title="list.name"  v-for="(list, index) in item.items" :key='index' @click='selectText(list)'/>
      </van-index-bar>
    </div>
  </div>
  <Loading v-else></Loading>
</template>

<script>
// api
import { reqOpenCity } from '@/apis/serviceApi'
// 组件
import NetWork from '@/components/network'
import Loading from '@/components/loading'
export default {
  data () {
    return {
      searchValue: '',
      networkError: '',
      showOpenCityContent: false,
      openCityList: []
    }
  },
  watch: {
    searchValue () {
      this.cityFilter()
    }
  },
  mounted () {
    document.title = '司机招募'
    this.getOpenCity()
  },
  components: {
    NetWork,
    Loading
  },
  methods: {
    refresh () {
      this.getOpenCity()
    },
    // 城市搜索
    cityFilter () {
      if (this.searchValue) {
        const cloneCityList = this.openCityList
        const newData = []
        for (let i = 0; i < cloneCityList.length; i++) {
          for (let j = 0; j< cloneCityList[i].items.length; j++) {
            console.log(cloneCityList[i].items[j].name)
            if(cloneCityList[i].items[j].name.indexOf(this.searchValue) > -1) {
              newData.push(
                {
                  title: cloneCityList[i].title,
                  key:  cloneCityList[i].key,
                  items:[
                    {
                      name: cloneCityList[i].items[j].name,
                      adcode: cloneCityList[i].items[j].adcode,
                      provinceCode: cloneCityList[i].items[j].provinceCode,
                    }
                  ]
                }
              )
              this.openCityList = newData
            }
          }
        }
      } else {
        this.getOpenCity()
      }
    },
    selectText (list) {
      this.$router.replace({
        path:'cpList',
        query:{
          cityCode: list.adcode,
          city: list.name
        }
      })
    },
    getOpenCity () {
      reqOpenCity().then(res => {
        console.log('开通城市列表==', res)
        if (res && res.code == 1) {
          this.showOpenCityContent = true
          this.networkError = false
          this.openCityList = res && res.data
        } else {
          this.showOpenCityContent = false
          this.networkError = true
        }
      })
      .catch(err => {
        console.log(err)
        this.showOpenCityContent = false
        this.networkError = true
      })
    }
  }

}
</script>

<style lang='less' scoped>
/deep/ .van-index-anchor{
  background: #f6f6f6;
  line-height: 88px;
}
</style>